(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketPlace.ElevateLife",
                {
                    url: "/ElevateLife",
                    component: "elevatelife",
                    PageTitle: "Elevate for Life",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("elevatelife",
        {
            templateUrl: "App/Tools/MarketPlace/ElevateLife/ElevateLife.html",
            controller: elevateLifeCtrl,
            bindings: {
                states: "<"
            }
        });

    elevateLifeCtrl.$inject = ["eligibilityFormDialog", "eligibilityFormApi", "surveys", "$q", "amplitudeService", "surveyRenewalDialog"];
    function elevateLifeCtrl(eligibilityFormDialog, eligibilityFormApi, surveys, $q, amplitudeService, surveyRenewalDialog) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                loading: true,
                intervals: [],
                submitted: false,
                pendingRenewal: false,
                hasPastRenewals: false,
                surveyId: null,
                openSurveyRenewalDialog: openSurveyRenewalDialog,
                getAndRefreshSurveyRenewals: getAndRefreshSurveyRenewals,
                openDialog: openDialog,
                logAmplitude: logAmplitude,
                init: init
            });

        function init() {
            surveys.then(function (s) {

                $ctrl.surveyId = s.elevateForLifeId;

                $ctrl.getAndRefreshSurveyRenewals().then(function () {
                    if ($ctrl.pendingRenewal)
                        $ctrl.openSurveyRenewalDialog();
                });

                var promises = [];
                promises.push(eligibilityFormApi.isEnrolled(s.elevateForLifePreMarch2019Id));
                promises.push(eligibilityFormApi.isEnrolled(s.elevateForLifeId));

                $q.all(promises).then(function (data) {
                    if (data[0] || data[1] === true) {
                        $ctrl.submitted = true;
                    }
                });

            }).then(function () { $ctrl.loading = false; });
        }

        function openSurveyRenewalDialog() {
            surveyRenewalDialog.open(event, $ctrl.surveyRenewals, $ctrl.surveyId).then(function (obj) {
                ng.extend($ctrl, obj);
            }).then(function () {
                $ctrl.getAndRefreshSurveyRenewals();
            });
        }

        function getAndRefreshSurveyRenewals() {

            return eligibilityFormApi.getSurveyRenewals($ctrl.surveyId).then(function (results) {
                $ctrl.surveyRenewals = results;
                var renewal = _.find(results, function (renewal) { return renewal.SurveyId === $ctrl.surveyId; });
                if (renewal) {
                    if (renewal.SurveyRenewalStatusId === 1) {
                        $ctrl.pendingRenewal = true;
                    }
                    else {
                        $ctrl.pendingRenewal = false;
                        $ctrl.hasPastRenewals = true;
                    }
                }

            }, function () {
                return null;
            });
        }

        /*  Open the Enrollment Form  */
        function openDialog(event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.elevateForLifeId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }

        function logAmplitude(propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        }

        $ctrl.init();
    }
})(window.app, window.angular); // jshint ignore:line